var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-row',{staticClass:"rj-line-form",attrs:{"type":"flex"}},[_vm._t("default",null,null,_vm.$attrs)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }